export const APP_FILE_CSIO_EDOCS_LIST = "/csio-edocs-list";
export const APP_FILE_MANAGE_CSIO_EDOCS = "/csio-edocs-list/manage-csio-edoc";
export const APP_FILE_CSIO_EDOCS = "/csio-edocs-list/manage-csio-edoc";